// @core/api/endpoints/fiscalization/list_shifts.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListShiftsResponse,
} from '../../../types/fiscalization';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/fiscalization';

/**
 * List shifts
 * Returns a paginated list of shifts for a fiscal point with optional filtering by status and date range.
 */
export async function ListShifts(
  fiscalPointId: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListShiftsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/fiscal-points/:fiscalPointId/shifts`;
  requestPath = requestPath.replace(':fiscalPointId', encodeURIComponent(fiscalPointId));
  const requestOptions = options;
  return client.get<ListShiftsResponse>(requestPath, { ...requestOptions, params });
}
